import { IResponse, Response, ResponseContext } from './Response';
import { Instance, SnapshotIn, cast, types } from 'mobx-state-tree';

export const ResponseStore = types
  .model('ResponseStore', {
    responses: types.maybe(types.array(Response)),
  })
  .actions(self => ({
    clearResponses() {
      self.responses = cast([]);
    },
    saveResponse(response: SnapshotIn<IResponse>) {
      if (!self.responses) {
        self.responses = cast([]);
      }
      const index = self.responses
        ?.findIndex(r => r.match(response));
      if (index !== undefined && index !== -1) {
        console.log(`Replacing response for ${response.questionId} (${response?.questionKey})`);
        self.responses?.splice(index, 1, response);
      } else {
        console.log(`Adding response for ${response.questionId} (${response?.questionKey})`);
        self.responses?.push(response);
      }
    },
    removeResponse(context: ResponseContext & {questionId: string}) {
      if (self.responses) {
        self.responses = cast(self.responses.filter(r =>
          !r.match(context)
        ));
      }
    },
    undoResponse() {
      self.responses?.pop();
    },
    consumeSurveyResponses(surveyId: string): IResponse[] {
      const responses = self.responses?.filter(r => r.surveyId === surveyId) || [];
      self.responses = cast(self.responses?.filter(r => r.surveyId !== surveyId));
      return responses;
    },
    clearSurveyResponses(surveyId: string) {
      if (self.responses) {
        self.responses = cast(self.responses.filter(r =>
          r.surveyId !== surveyId
        ));
      }
    },
    clearSessionResponses(sessionId: string, pathId?: string) {
      if (self.responses) {
        self.responses = cast(self.responses.filter(r =>
          !(r.sessionId === sessionId && (pathId ? r.pathId === pathId : true))
        ));
      }
    },
  }))
  .views(self => ({
    getResponse(context: ResponseContext & {questionId: string}): IResponse | undefined {
      return self.responses?.find(r => r.match(context));
    },
    getResponsesForSurvey(surveyId: string): IResponse[] {
      return self.responses?.filter(r => r.match({surveyId})) || [];
    },
    getResponsesForSession(sessionId: string, pathId?: string): IResponse[] {
      return self.responses?.filter(r => r.match({sessionId, pathId})) || [];
    }
  }));

export interface IResponseStore extends Instance<typeof ResponseStore> {}
